import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import axios from 'axios'

const request = axios.create({
  timeout: 180000,
  headers: {
    'Content-Type': 'application/json'
  }
})

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    let deviceId = localStorage.getItem('deviceId')
    if (!deviceId) {
      deviceId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      localStorage.setItem('deviceId', deviceId)
    }

    // Determine deviceType (simple approach for request interceptor)
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches
    const isTablet = window.matchMedia('(min-width: 768px)').matches
    const deviceType = isDesktop ? 'desktop' : isTablet ? 'tablet' : 'mobile'

    config.headers.deviceId = deviceId
    config.headers.deviceType = deviceType
    config.headers.appVersion = '1.0.0'

    return config
  },
  (error) => Promise.reject(error)
)

request.interceptors.response.use(
  (response: AxiosResponse) => {
    const data = response.data
    // Handle custom business logic code for unauthorized
    if (data && data.code === 401) {
      window.dispatchEvent(new Event('auth:unauthorized'))
      return Promise.reject(new Error(data.message || 'Unauthorized'))
    }
    return data
  },
  (error) => {
    const status = error.response?.status
    if (status === 401) {
      // Token expired or invalid

      // We can also trigger the store reset by using a window event or importing store directly
      // (though importing store directly in request.ts might cause circular dependency issues in some setups,
      // so dispatching a custom event is a safe way, or simply reloading the page)
      window.dispatchEvent(new Event('auth:unauthorized'))
    }
    return Promise.reject(error)
  }
)

export function get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  return request.get(url, config)
}

export function post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
  return request.post(url, data, config)
}

export function put<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
  return request.put(url, data, config)
}

export function del<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  return request.delete(url, config)
}

export default request
